export enum AssignmentType {
	'gad7' = 'gad7',
	'phq9' = 'phq9',
	'satisfaction' = 'satisfaction',
	'goal-sheet' = 'goal-sheet',
	'payment' = 'payment',
}